import { render, staticRenderFns } from "./ProductCosts.vue?vue&type=template&id=fb2fa2b6&"
import script from "./ProductCosts.vue?vue&type=script&lang=js&"
export * from "./ProductCosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports